import axios from 'axios';
import authHeader from '../auth-header';
import { NewDictBodyTest, NewClientBodyTest, ClientBodyTest } from '../../types/types'
import { API_URL } from '../../constants/api'

class ClientBodyTestsService {
  getClientBodyTest(clientId: string) {
    return axios.get(API_URL + '/get_client_body_tests/' + clientId, { headers: authHeader() });
  }

  postClientBodyTestPerUser(requestBody: NewClientBodyTest) {
    return axios.post(API_URL + '/add_client_body_test', requestBody, { headers: authHeader() })
      .then(response => {
        console.log('Odpowiedź z serwera:', response.data);
      })
      .catch(error => {
        console.error('Błąd podczas wysyłania zapytania:', error);
      });
  }

  updateClientBodyTest(testId: string, payload: Partial<ClientBodyTest>) {
    return axios.patch(`${API_URL}/update_client_body_test/${testId}`, payload, {
      headers: authHeader(),
    });
  }

  deleteClientBodyTest(id: string) {
    return axios.delete(`${API_URL}/delete_client_body_test/${id}`, {
      headers: authHeader()
    });
  }
}


export default new ClientBodyTestsService();
